import { StaticImageData } from 'next/image'

import sisterImg from '@/assets/images/sister.png'
import userImg from '@/assets/images/user-1.jpeg'
import Resources from '~/@types/resources'

type ResourceKey = keyof Resources['common']

export type Testimonial = {
  id: number
  nameKey: ResourceKey
  countryKey: ResourceKey
  textKey: ResourceKey
  img: StaticImageData
}

export const TESTIMONIALS: Testimonial[] = [
  {
    id: 1,
    nameKey: 'testimonials.1.name',
    countryKey: 'testimonials.1.country',
    textKey: 'testimonials.1.text',
    img: sisterImg,
  },
  {
    id: 2,
    nameKey: 'testimonials.2.name',
    countryKey: 'testimonials.2.country',
    textKey: 'testimonials.2.text',
    img: userImg,
  },
  {
    id: 3,
    nameKey: 'testimonials.3.name',
    countryKey: 'testimonials.3.country',
    textKey: 'testimonials.3.text',
    img: sisterImg,
  },
  {
    id: 4,
    nameKey: 'testimonials.4.name',
    countryKey: 'testimonials.4.country',
    textKey: 'testimonials.4.text',
    img: sisterImg,
  },
]
